import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import axios from 'axios'

Vue.use(Vuex);

function setEnv() {
	var env = 'live';
	var protocol = 'https://';
	var urlAPI = 'rcapi.todomath.com';
	
	if (process.env.NODE_ENV !== undefined) {
		env = process.env.ENV
		protocol = process.env.PROTOCOL
		urlAPI = process.env.URLAPI
	}
	return {
		env: env,
		protocol: protocol,
		urlAPI: urlAPI
	}
}

export const store = new Vuex.Store({
	state: {
		lang: '',
		appStoreUrl: '',
		googlePlayUrl: '',
		parentEmail: '',
		sessionId: '',
        googleToken: '',
        email: '',
        password: '',
		errCode: '',
		env: setEnv(),
		width: 0,
		accountId: '',
		groupId: '',
		accountType: '',
		supportKey: '',
		userName: '',
        servertime: null
	},
	mutations: {
		setStoreLang(state, lang) {
			state.lang = lang;
		},
		setLanguage(state, lang) {
			var setLang = '';
			switch (lang) {
				case 'en':
				case 'ko':
				case 'cn':
				case 'ja':
					state.lang = lang;
					break;
				default:
					state.lang = 'en';
					break;
			}
			VueCookies.set('language', state.lang);
		},
		setToBrowserLanguage(state) {
			var browserLanguage = navigator.language || navigator.userLanguage;
			browserLanguage = browserLanguage ? browserLanguage : 'en';
			browserLanguage = browserLanguage.substring(0, 2);
			state.lang = browserLanguage;

			VueCookies.set('language', state.lang);
		},
		setAppStoreUrl(state, url) {
			state.appStoreUrl = url;
		},
		setGooglePlayUrl(state, url) {
			state.googlePlayUrl = url;
		},
		setSessionId(state, sessionId) {
			VueCookies.set('sessionId', sessionId)//, 60 * 60 * 24, null, 'todoenglish.com');
			state.sessionId = sessionId;
		},
		delSessionId(state) {
            VueCookies.remove('sessionId')//, 'todoenglish.com');
			state.sessionId = '';
        },
        setGoogleToken(state, token) {
            state.googleToken = token;
            state.email = '';
            state.password = '';
        },
        delGoogleToken(state) {
			state.googleToken = '';
            state.email = '';
            state.password = '';
        },
        setEmailSignup(state, { email, password }) {
			state.email = email;
			state.password = password;
			state.googleToken = '';
        },
        delEmailSignup(state) {
			state.email = '';
			state.password = '';
			state.googleToken = '';
        },
		setErrCode(state, errCode) {
			state.errCode = errCode;
		},
		setWidth(state, width) {
			state.width = width
		},
		
		setIds(state, data) {
			VueCookies.set('authToken', data.authToken)
			state.authToken = data.authToken

			VueCookies.set('sessionId', data.sessionId)
			state.sessionId = data.sessionId;

			VueCookies.set('accountId', data.accountId)
			state.accountId = data.accountId;

			VueCookies.set('groupId', data.groupId)
			state.groupId = data.groupId;

			VueCookies.set('email', data.email)
			state.email = data.email;
			
			VueCookies.set('supportKey', data.supportKey)
			state.supportKey = data.supportKey;

			const email = data.email != 'none' ? data.email : data.supportKey
            var userName = email
            if (email.indexOf('@') > -1) {
                userName = email.split('@')[0]
			}
			
			VueCookies.set('userName', userName)
			state.userName = userName;
		},

		delIds(state) {
			VueCookies.remove('sessionId')
			state.sessionId = '';

			VueCookies.remove('accountId')
			state.accountId = '';

			VueCookies.remove('groupId')
			state.groupId = '';

			VueCookies.remove('email')
			state.email = '';

			VueCookies.remove('accountType')
			state.accountType = '';

			VueCookies.remove('supportKey')
			state.supportKey = '';

			VueCookies.remove('userName')
			state.userName = '';
			
			VueCookies.remove('authToken')
			state.authToken = '';

			axios.defaults.headers.common['Authorization'] = `Bearer `
		},
		setAccountType(state, accountType) {
			VueCookies.set('accountType', accountType)
			state.accountType = accountType;
		},
        setServerTime(state, time) {
            state.servertime = time
        }
	},
	getters: {
		getSessionId(state) {
			return state.sessionId == '' || state.sessionId == undefined || state.sessionId == null ? VueCookies.get('sessionId') : state.sessionId
		},
		isSignedIn(state) {
			const token = state.authToken == '' || state.authToken == undefined  || state.authToken == null ? VueCookies.get('authToken') : state.authToken
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
			return token != '' && token != null && token != undefined
		},
		getEmail(state) {
			return state.email == '' || state.email == null ? VueCookies.get('email') : state.email
		},
		getAccountId(state) {
			return state.accountId == '' || state.accountId == null ? VueCookies.get('accountId') : state.accountId
		}

	},
	actions: {
        serviceTime({commit}) {
            return new Promise(() => {
				axios.get('/service/time').then(function(res) {
                    if (res.data.result) {
                        const timeString = res.data.data.time

                        const year = parseInt(timeString.slice(0, 4))
                        const month = parseInt(timeString.slice(4, 6)) - 1
                        const dates = parseInt(timeString.slice(6, 8))
                        const hour = parseInt(timeString.slice(8, 10))
                        const minute = parseInt(timeString.slice(10, 12))
                        const second = parseInt(timeString.slice(12, 14))

                        const date = new Date(Date.UTC(year, month, dates, hour, minute, second))
                        
                        commit('setServerTime', date)

                    }
				})
			});
        },
		signin({commit, state}, {email, password}) {
			return new Promise((resolve, reject) => {
				axios.post('/account/signin', {
                    accountType: 'personal',
                    email: email,
                    password: password,
                    getSessionId: true,
                    product: 'todoenglish',
    				fromWeb: true
				}, {
					headers: {
						'content-type': 'application/json; charset=UTF-8'
					}
				}).then(function(rs) {
					if (!rs.data.result) {
						commit('delIds')
						commit('setErrCode', rs.data.errorCode);
						reject('error');
					} else {
						commit('setIds', rs.data.data)
						commit('setAccountType', 'personal')
						resolve();
					}
				}).catch(function(er) {
					commit('delIds')
					commit('setErrCode', 'CA99');
					reject('error');
				});
			});
		},
		signinKakao({commit, state}, {token}) {
			return new Promise((resolve, reject) => {
				axios.post('/account/signinKakaoOAuth', {
					access_token: token,
					product: 'todoenglish'
                } , {
					headers: {
						'content-type': 'application/json; charset=UTF-8'
					}
				}).then(function(rs) {
					if (!rs.data.result) {
						commit('delIds')
						commit('setErrCode', rs.data.errorCode);
						reject('error');
					} else {
						commit('setIds', rs.data.data)
						commit('setAccountType', 'kakao')
						resolve();
					}
				}).catch(function(er) {
					commit('delIds')
					commit('setErrCode', 'CA99');
					reject('error');
				});
			});
		},
		signinGoogle({commit, state}, {token, marketingAgreement}) {
			return new Promise((resolve, reject) => {
				axios.post('/account/signinGoogleOAuth', {
                    token: token,
					marketingAgreement: marketingAgreement,
					product: 'todoenglish'
				}, {
					headers: {
						'content-type': 'application/json; charset=UTF-8'
					}
				}).then(function(rs) {
					if (!rs.data.result) {
						commit('delIds')
						commit('setErrCode', rs.data.errorCode);
						reject('error');
					} else {
						commit('setIds', rs.data.data)
						commit('setAccountType', 'google')
						resolve();
					}
				}).catch(function(er) {
					commit('delIds')
					commit('setErrCode', 'CA99');
					reject('error');
				});
			});
		},
		signout({commit}, {}) {
			commit('delIds')
		},
		
        redirect() {
			console.log("do not use")
			/*
            const { origin, search } = window.location;
            let path = "/";
            if (search) {
                const tokens = search.replace(/^\?/, "").split("&");
                for (let i = 0; i < tokens.length; i++) {
                    const pair = tokens[i].split("=");
                    if (decodeURIComponent(pair[0]) == "redirect") {
                        path = decodeURIComponent(pair[1]);
                    }
                }
			}
			
            if (path.startsWith('/')) {
                path = origin + path;
            }
			window.location.href = path;
			*/
		},
		
	
        verifySession({commit, state}, {sessionId}) {
			return new Promise((resolve, reject) => {
				axios.post('/session/verify', {
                    sessionId: sessionId
				}, {
					headers: {
						'content-type': 'application/json; charset=UTF-8'
					}
				}).then(function(rs) {
					if (!rs.data || !rs.data.result || !rs.data.data.accountId) {
						commit('delIds')
						reject('error');
					} else {
						resolve();
					}
				}).catch(function(er) {
					commit('delIds')
					reject('error');
				});
			});
		},
		connectKakao({commit, state}, {user}) {
			return new Promise((resolve, reject) => {
				axios.post('/account/connectKakao', {
					accountId: VueCookies.get('accountId'),
					accessToken: user.access_token,
					product: 'todoenglish'
                } , {
					headers: {
						'content-type': 'application/json; charset=UTF-8'
					}
				}).then(function(rs) {
					if (!rs.data.result) {
						// commit('delIds')
						commit('setErrCode', rs.data.errorCode);
						reject('error');
					} else {
						// commit('setIds', rs.data.data)
						// commit('setAccountType', 'kakao')
						resolve();
					}
				}).catch(function(er) {
					reject('error')
				});
			});
		}
	}
});



VueCookies.get('language') ? store.commit('setStoreLang', VueCookies.get('language')) : store.commit('setToBrowserLanguage');
